import React from 'react';
import { Grid, TextField, Button, Box, Typography } from '@mui/material';

const SignatureSection = ({ formData, handleChange, handleSignatureOpen }) => {
  const staff = [
    { label: "Scrub Nurse", sigKey: "scrub_nurse_signature", nameKey: "scrub_nurse_name", dateKey: "scrub_nurse_datetime" },
    { label: "Witness / Circulating Nurse", sigKey: "circulating_nurse_signature", nameKey: "circulating_nurse_name", dateKey: "circulating_nurse_datetime" },
  ];

  return (
    <Box sx={{ mt: 4, pt: 4, borderTop: '2px dashed #008080' }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 3, fontWeight: 'bold' }}>
        Step 10: Final Signatures
      </Typography>
      
      <Grid container spacing={4}>
        {staff.map((person) => (
          <Grid item xs={12} sm={6} key={person.sigKey}>
            <Box sx={{ p: 2, border: '1px solid #e0e0e0', borderRadius: 2, backgroundColor: '#fafafa' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: '#008080' }}>
                {person.label}
              </Typography>
              <TextField
                name={person.nameKey}
                value={formData[person.nameKey] || ''}
                fullWidth
                label="Full Name"
                variant="outlined"
                size="small"
                sx={{ mb: 2 }}
                onChange={handleChange}
              />
              <TextField
                name={person.dateKey}
                value={formData[person.dateKey] || ''}
                fullWidth
                label="Date & Time"
                type="datetime-local"
                variant="outlined"
                size="small"
                sx={{ mb: 2 }}
                InputLabelProps={{ shrink: true }}
                onChange={handleChange}
              />
              <Button
                variant="outlined"
                fullWidth
                color="primary"
                onClick={() => handleSignatureOpen(person.sigKey)}
              >
                {formData[person.sigKey] ? 'Change Signature' : 'Provide Signature'}
              </Button>
              {formData[person.sigKey] && (
                <Box sx={{ mt: 2, border: "1px solid #ccc", p: 1, borderRadius: 1, textAlign: 'center', backgroundColor: '#fff' }}>
                  <img src={`data:image/png;base64,${formData[person.sigKey]}`} alt="Signature" style={{ maxHeight: '100px', maxWidth: '100%' }} />
                </Box>
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SignatureSection;
